import {md2html} from '@github-ui/md2html'
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  updateIssueCommentBodyMutation,
  updateIssueCommentBodyMutation$data,
  UpdateIssueCommentInput,
} from './__generated__/updateIssueCommentBodyMutation.graphql'

export function commitUpdateIssueCommentBodyMutation({
  environment,
  input: {id, body, bodyVersion},
  onCompleted,
  onError,
  withOptimisticResponse = false,
}: {
  environment: Environment
  input: {id: string; body: string | null; bodyVersion: string}
  onCompleted?: (response?: updateIssueCommentBodyMutation$data) => void
  onError?: (error: Error) => void
  withOptimisticResponse?: boolean
}) {
  if (!body) {
    return
  }

  const inputHash: UpdateIssueCommentInput = {
    id,
    body,
    bodyVersion,
  }

  return commitMutation<updateIssueCommentBodyMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation updateIssueCommentBodyMutation($input: UpdateIssueCommentInput!) @raw_response_type {
        updateIssueComment(input: $input) {
          issueComment {
            bodyVersion
            ...IssueCommentViewerMarkdownViewer
          }
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    optimisticResponse: withOptimisticResponse
      ? {
          updateIssueComment: {
            issueComment: {
              id,
              body,
              bodyHTML: md2html(body),
              bodyVersion,
              viewerCanUpdate: false,
            },
          },
        }
      : undefined,
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
